import { render, staticRenderFns } from "./interv-img.vue?vue&type=template&id=2e6b5c39"
import script from "./interv-img.vue?vue&type=script&lang=js"
export * from "./interv-img.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports